import type { Doc } from "building-types/doc";
import type {
  FloorHandle,
  FloorSystemHandle,
  FoundationHandle,
  FoundationSystemHandle,
  RoofHandle,
  RoofSystemHandle,
} from "building-types/handles/docEntityHandleTypes";

export function docGetFloorSystemFloorHandles(doc: Doc, handle: FloorSystemHandle): FloorHandle[] {
  const floorHandles: FloorHandle[] = [];
  for (const floorId in doc.floors) {
    const floor = doc.floors[floorId];
    if (floor.parentId === handle.id) {
      floorHandles.push({
        type: "FLOOR",
        id: floorId,
      });
    }
  }

  return floorHandles;
}

export function docGetFloorSystemFloorHandlesSortedBySortIndex(doc: Doc, handle: FloorSystemHandle): FloorHandle[] {
  const handles = docGetFloorSystemFloorHandles(doc, handle);
  return [...handles].sort((a, b) => doc.floors[a.id].sortIndex - doc.floors[b.id].sortIndex);
}

export function docGetFoundationSystemFoundationHandles(doc: Doc, handle: FoundationSystemHandle): FoundationHandle[] {
  const foundationHandles: FoundationHandle[] = [];
  for (const foundationId in doc.foundations) {
    const foundation = doc.foundations[foundationId];
    if (foundation.parentId === handle.id) {
      foundationHandles.push({
        type: "FOUNDATION",
        id: foundationId,
      });
    }
  }

  return foundationHandles;
}

export function docGetRoofSystemRoofHandles(doc: Doc, handle: RoofSystemHandle): RoofHandle[] {
  const roofHandles: RoofHandle[] = [];
  for (const roofId in doc.roofs) {
    const roof = doc.roofs[roofId];
    if (roof.parentId === handle.id) {
      roofHandles.push({
        type: "ROOF",
        id: roofId,
      });
    }
  }

  return roofHandles;
}
